import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import UserAvatar from 'react-user-avatar';
import MaterialIcon from 'material-icons-react';
import DatePicker from 'react-date-picker';
import TimePicker from 'react-time-picker';
import VendorMenu from '../../components/VendorMenu';
import firebase from '../../config/firebase';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-time-picker/dist/TimePicker.css';
// Reducers
import { getMode } from '../../sagas/setModeSaga/reducer';
import {
  getSocialConfig,
  getVendorSocialContent,
  getVendorSocialPosts,
  createVendorSocialPost,
  updateVendorSocialPost,
  deleteVendorSocialPost,
  pushVendorSocialPostNow,
} from '../../sagas/socialMediaSaga/reducer';

export class VendorSocialMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPicker: false,
      showHelp: false,
      createOpen: false,
      contentType: 'promotion',
      selectedContentId: '',
      postText: '',
      selectedPlatforms: [],
      platformOverrides: {},
      status: 'draft',
      editingPostId: null,
      scheduledDate: null,
      scheduledTime: '09:00',
      scheduleValidationError: '',
    };
    this.showPicker = this.showPicker.bind(this);
  }

  UNSAFE_componentWillMount() {
    document.title = 'Social Media';
    if (this.props.mode !== 2) {
      this.props.getMode(2);
    }
  }

  componentDidMount() {
    if (this.props.vendor && this.props.vendor.vendorId) {
      this.props.getSocialConfig();
      this.props.getVendorSocialPosts(this.props.vendor.vendorId);
      this.props.getVendorSocialContent(
        this.props.vendor.vendorId,
        this.state.contentType,
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.vendor &&
      this.props.vendor.vendorId &&
      prevProps.vendor !== this.props.vendor
    ) {
      this.props.getSocialConfig();
      this.props.getVendorSocialPosts(this.props.vendor.vendorId);
      this.props.getVendorSocialContent(
        this.props.vendor.vendorId,
        this.state.contentType,
      );
    }

    if (prevState.contentType !== this.state.contentType) {
      this.props.getVendorSocialContent(
        this.props.vendor.vendorId,
        this.state.contentType,
      );
      this.setState({
        selectedContentId: '',
        postText: '',
      });
    }
  }

  showPicker(mode) {
    this.setState({
      showPicker: mode,
    });
  }

  togglePlatform(platformId) {
    let selectedPlatforms = [...this.state.selectedPlatforms];

    if (selectedPlatforms.includes(platformId)) {
      selectedPlatforms = selectedPlatforms.filter(
        (item) => item !== platformId,
      );
    } else {
      selectedPlatforms.push(platformId);
    }

    this.setState({
      selectedPlatforms,
    });
  }

  updatePlatformOverride(platformId, key, value) {
    this.setState((prevState) => ({
      platformOverrides: {
        ...prevState.platformOverrides,
        [platformId]: {
          ...(prevState.platformOverrides[platformId] || {}),
          [key]: value,
        },
      },
    }));
  }

  getPlatformCropSpec(platform) {
    return {
      width:
        platform && platform.imageWidth && platform.imageWidth > 0
          ? platform.imageWidth
          : 1200,
      height:
        platform && platform.imageHeight && platform.imageHeight > 0
          ? platform.imageHeight
          : 630,
    };
  }

  getPlatformImageSource(platformId) {
    const selectedContent = this.getSelectedContent();
    const baseImage =
      selectedContent && selectedContent.image
        ? selectedContent.image
        : null;

    const override = this.state.platformOverrides[platformId] || {};
    return override.imageUrl || baseImage;
  }

  resetPlatformImageEdit(platformId) {
    this.updatePlatformOverride(platformId, 'cropScale', 1);
    this.updatePlatformOverride(platformId, 'cropX', 0);
    this.updatePlatformOverride(platformId, 'cropY', 0);
  }

  uploadPlatformImage(platformId, file) {
    if (!file) {
      return;
    }

    let previewUrl = null;
    try {
      previewUrl = URL.createObjectURL(file);
    } catch (error) {
      previewUrl = null;
    }

    if (previewUrl) {
      this.updatePlatformOverride(platformId, 'imageUrl', previewUrl);
      this.resetPlatformImageEdit(platformId);
      this.updatePlatformOverride(platformId, 'cropConfirmed', false);
    }

    if (!this.props.vendor || !this.props.vendor.vendorId) {
      this.updatePlatformOverride(
        platformId,
        'imageError',
        'Image selected for editing. Upload is unavailable right now.',
      );
      return;
    }

    this.updatePlatformOverride(platformId, 'imageUploading', true);
    this.updatePlatformOverride(platformId, 'imageError', null);

    const vendorId = this.props.vendor.vendorId;
    const extension =
      file.name && file.name.indexOf('.') !== -1
        ? file.name.split('.').pop()
        : 'jpg';
    const fileName = `${platformId}_${Date.now()}.${extension}`;
    const uploadPath = `vendor_images/${vendorId}/social_media/${fileName}`;

    const imageRef = firebase.storage().ref(uploadPath);

    imageRef
      .put(file)
      .then(() => imageRef.getDownloadURL())
      .then((url) => {
        if (previewUrl && previewUrl.indexOf('blob:') === 0) {
          try {
            URL.revokeObjectURL(previewUrl);
          } catch (error) {
            // ignore revoke errors
          }
        }
        this.updatePlatformOverride(platformId, 'imageUrl', url);
        this.resetPlatformImageEdit(platformId);
        this.updatePlatformOverride(
          platformId,
          'cropConfirmed',
          false,
        );
        this.updatePlatformOverride(
          platformId,
          'imageUploading',
          false,
        );
      })
      .catch((error) => {
        this.updatePlatformOverride(
          platformId,
          'imageUploading',
          false,
        );
        this.updatePlatformOverride(
          platformId,
          'imageError',
          error && error.message
            ? error.message
            : 'Image upload failed. Using selected image preview.',
        );
      });
  }

  getSelectedContent() {
    if (this.state.selectedContentId === '') {
      return null;
    }

    const selected = this.props.vendorContent.find((item) => {
      return item.id === this.state.selectedContentId;
    });

    return selected || null;
  }

  resetComposer(closePanel = true) {
    this.setState({
      createOpen: closePanel ? false : this.state.createOpen,
      selectedContentId: '',
      postText: '',
      selectedPlatforms: [],
      platformOverrides: {},
      status: 'draft',
      editingPostId: null,
      scheduledDate: null,
      scheduledTime: '09:00',
      scheduleValidationError: '',
    });
  }

  hasFacebookSelected(platforms = []) {
    return (platforms || []).some((platformId) => {
      if (typeof platformId !== 'string') {
        return false;
      }
      return platformId.toLowerCase().trim() === 'facebook';
    });
  }

  getScheduledDateTimeIso() {
    if (!this.state.scheduledDate || !this.state.scheduledTime) {
      return null;
    }

    const [hoursText, minutesText] =
      this.state.scheduledTime.split(':');
    const hours = Number(hoursText);
    const minutes = Number(minutesText);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
      return null;
    }

    const scheduled = new Date(this.state.scheduledDate);
    scheduled.setHours(hours, minutes, 0, 0);
    return scheduled.toISOString();
  }

  editPost(post) {
    const initialScheduledDate = post.scheduledFor
      ? new Date(post.scheduledFor)
      : null;
    const initialScheduledTime = post.scheduledFor
      ? `${String(initialScheduledDate.getHours()).padStart(2, '0')}:${String(
          initialScheduledDate.getMinutes(),
        ).padStart(2, '0')}`
      : '09:00';

    this.setState({
      createOpen: true,
      editingPostId: post.id,
      contentType: post.contentType || 'promotion',
      selectedContentId:
        post.sourceContentId ||
        (post.sourceContent && post.sourceContent.id) ||
        '',
      postText: post.postText || '',
      selectedPlatforms: post.selectedPlatforms || [],
      platformOverrides: post.platformOverrides || {},
      status: post.status || 'draft',
      scheduledDate: initialScheduledDate,
      scheduledTime: initialScheduledTime,
      scheduleValidationError: '',
    });
  }

  createPost() {
    if (this.state.selectedPlatforms.length === 0) {
      return;
    }

    if (this.state.status === 'published') {
      this.pushComposerToSocialNow();
      return;
    }

    const scheduledFor =
      this.state.status === 'queued'
        ? this.getScheduledDateTimeIso()
        : null;

    if (this.state.status === 'queued' && !scheduledFor) {
      this.setState({
        scheduleValidationError:
          'Select a valid publish date and time to schedule this post.',
      });
      return;
    }

    const selectedContent = this.getSelectedContent();

    const payload = {
      vendorId: this.props.vendor.vendorId,
      vendorName: this.props.vendor.businessName || '',
      contentType: this.state.contentType,
      sourceContentId:
        selectedContent !== null ? selectedContent.id : null,
      sourceContent: selectedContent,
      postText: this.state.postText,
      selectedPlatforms: this.state.selectedPlatforms,
      platformOverrides: this.state.platformOverrides,
      status: this.state.status,
      scheduledFor,
    };

    if (this.state.editingPostId) {
      this.props.updateVendorSocialPost({
        ...payload,
        id: this.state.editingPostId,
      });
      console.log('Update vendor social post (DB write skipped)', {
        ...payload,
        id: this.state.editingPostId,
      });
    } else {
      this.props.createVendorSocialPost(payload);
      console.log(
        'Create vendor social post (DB write skipped)',
        payload,
      );
    }

    this.resetComposer(true);
  }

  pushComposerToSocialNow() {
    if (this.state.selectedPlatforms.length === 0) {
      return;
    }

    if (!this.hasFacebookSelected(this.state.selectedPlatforms)) {
      this.setState({
        scheduleValidationError:
          'Select Facebook to publish with the current backend setup.',
      });
      return;
    }

    const selectedContent = this.getSelectedContent();
    const payload = {
      id: this.state.editingPostId || null,
      vendorId: this.props.vendor.vendorId,
      vendorName: this.props.vendor.businessName || '',
      contentType: this.state.contentType,
      sourceContentId:
        selectedContent !== null ? selectedContent.id : null,
      sourceContent: selectedContent,
      postText: this.state.postText,
      selectedPlatforms: this.state.selectedPlatforms,
      platformOverrides: this.state.platformOverrides,
      status: 'published',
      scheduledFor: null,
    };

    this.props.pushVendorSocialPostNow(payload);
    console.log(
      'Push to social media now (DB/API write skipped)',
      payload,
    );

    this.resetComposer(true);
  }

  removePost(postId) {
    this.props.deleteVendorSocialPost(
      this.props.vendor.vendorId,
      postId,
    );
    console.log('Delete vendor social post (DB write skipped)', {
      vendorId: this.props.vendor.vendorId,
      postId,
    });
  }

  pushSavedPost(post) {
    if (!this.hasFacebookSelected(post.selectedPlatforms || [])) {
      this.setState({
        scheduleValidationError:
          'Saved post must include Facebook before publishing.',
      });
      return;
    }

    const payload = {
      ...post,
      id: post.id,
      vendorId: this.props.vendor.vendorId,
      vendorName:
        this.props.vendor.businessName || post.vendorName || '',
      status: 'published',
    };

    this.props.pushVendorSocialPostNow(payload);
    console.log(
      'Push saved post to social media (DB/API write skipped)',
      payload,
    );
  }

  getContentTypeSelector() {
    const options = [
      { id: 'promotion', label: 'Promotion' },
      { id: 'location', label: 'Location' },
      { id: 'event', label: 'Event' },
    ];

    return (
      <div style={{ marginBottom: '12px' }}>
        <p style={{ fontWeight: 600, marginBottom: '8px' }}>
          1) Choose content type
        </p>
        <div>
          {options.map((option) => (
            <button
              key={option.id}
              className={
                this.state.contentType === option.id
                  ? 'saveButton'
                  : 'cancelButton'
              }
              style={{
                marginRight: '10px',
                marginBottom: '8px',
                borderRadius: '6px',
              }}
              onClick={() => {
                this.setState({
                  contentType: option.id,
                });
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    );
  }

  getContentPicker() {
    return (
      <div style={{ marginBottom: '12px' }}>
        <p style={{ fontWeight: 600, marginBottom: '8px' }}>
          2) Select your {this.state.contentType}
        </p>
        <select
          className="form-control"
          value={this.state.selectedContentId}
          onChange={(event) => {
            const nextId = event.target.value;
            const selectedItem = this.props.vendorContent.find(
              (item) => item.id === nextId,
            );
            const seededText = selectedItem
              ? [selectedItem.title, selectedItem.description]
                  .filter((part) => part && part.trim() !== '')
                  .join('\n\n')
              : '';

            this.setState({
              selectedContentId: nextId,
              postText: seededText,
            });
          }}
        >
          <option value="">Select content</option>
          {this.props.vendorContent.map((item) => (
            <option key={item.id} value={item.id}>
              {item.title}
            </option>
          ))}
        </select>
      </div>
    );
  }

  getComposer() {
    const selectedContent = this.getSelectedContent();

    return (
      <div style={{ marginBottom: '12px' }}>
        <p style={{ fontWeight: 600, marginBottom: '8px' }}>
          4) Compose post
        </p>
        {selectedContent && (
          <div
            style={{
              border: '1px solid #e6e6e6',
              borderRadius: '8px',
              padding: '10px',
              marginBottom: '8px',
              background: '#fafafa',
            }}
          >
            {selectedContent.image && (
              <img
                src={selectedContent.image}
                alt={selectedContent.title}
                style={{
                  width: '100%',
                  maxHeight: '220px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                  marginBottom: '10px',
                }}
              />
            )}
            <p style={{ margin: 0, fontWeight: 600 }}>
              {selectedContent.title}
            </p>
            <p style={{ margin: '5px 0 0 0' }}>
              {selectedContent.description}
            </p>
          </div>
        )}

        <textarea
          className="form-control"
          rows="5"
          placeholder="Edit selected content..."
          value={this.state.postText}
          onChange={(event) => {
            this.setState({
              postText: event.target.value,
            });
          }}
        />
      </div>
    );
  }

  getPlatformSelector() {
    if (this.props.socialMedia.loadingConfig) {
      return (
        <div style={{ marginBottom: '12px' }}>
          <p style={{ fontWeight: 600, marginBottom: '8px' }}>
            3) Select platforms
          </p>
          <p>Loading available platforms...</p>
        </div>
      );
    }

    const platformsToShow =
      this.props.platforms && this.props.platforms.length > 0
        ? this.props.platforms
        : [];

    if (platformsToShow.length === 0) {
      return (
        <div style={{ marginBottom: '12px' }}>
          <p style={{ fontWeight: 600, marginBottom: '8px' }}>
            3) Select platforms
          </p>
          <p>No platforms available. Contact support.</p>
        </div>
      );
    }

    return (
      <div style={{ marginBottom: '12px' }}>
        <p style={{ fontWeight: 600, marginBottom: '8px' }}>
          3) Select platforms
        </p>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns:
              'repeat(auto-fill, minmax(150px, 1fr))',
            gap: '12px',
          }}
        >
          {platformsToShow.map((platform) => (
            <div
              key={platform.id}
              style={{
                border: this.state.selectedPlatforms.includes(
                  platform.id,
                )
                  ? '2px solid #f21d59'
                  : '1px solid #e6e6e6',
                borderRadius: '8px',
                padding: '10px',
                cursor: 'pointer',
                background: this.state.selectedPlatforms.includes(
                  platform.id,
                )
                  ? '#fff5f8'
                  : '#fff',
                opacity: platform.active ? 1 : 0.6,
              }}
              onClick={() => {
                if (platform.active) {
                  this.togglePlatform(platform.id);
                }
              }}
            >
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  margin: 0,
                }}
              >
                <input
                  type="checkbox"
                  checked={this.state.selectedPlatforms.includes(
                    platform.id,
                  )}
                  onChange={() => {
                    if (platform.active) {
                      this.togglePlatform(platform.id);
                    }
                  }}
                  disabled={!platform.active}
                  style={{ marginRight: '8px' }}
                />{' '}
                <span style={{ fontWeight: 600 }}>
                  {platform.name}
                </span>
              </label>
              {!platform.active && (
                <small style={{ display: 'block', marginTop: '4px' }}>
                  (Inactive)
                </small>
              )}
            </div>
          ))}
        </div>
        {this.state.selectedPlatforms.length > 0 && (
          <p style={{ marginTop: '8px', fontSize: '12px' }}>
            {this.state.selectedPlatforms.length} platform
            {this.state.selectedPlatforms.length !== 1
              ? 's'
              : ''}{' '}
            selected
          </p>
        )}
      </div>
    );
  }

  getPerPlatformFormatting() {
    if (this.state.selectedPlatforms.length === 0) {
      return null;
    }

    return (
      <div style={{ marginBottom: '12px' }}>
        <p style={{ fontWeight: 600, marginBottom: '8px' }}>
          5) Platform formatting + crop confirmation
        </p>
        {this.state.selectedPlatforms.map((platformId) => {
          const platform = this.props.platforms.find(
            (p) => p.id === platformId,
          );
          const fileInputId = `social-image-upload-${platformId}`;
          const override =
            this.state.platformOverrides[platformId] || {};
          const cropSpec = this.getPlatformCropSpec(platform);
          const cropPreviewWidth = 260;
          const cropPreviewHeight = Math.max(
            120,
            Math.round(
              (cropSpec.height / cropSpec.width) * cropPreviewWidth,
            ),
          );
          const imageSource = this.getPlatformImageSource(platformId);
          const cropScale =
            override.cropScale !== undefined ? override.cropScale : 1;
          const cropX =
            override.cropX !== undefined ? override.cropX : 0;
          const cropY =
            override.cropY !== undefined ? override.cropY : 0;

          return (
            <div
              key={platformId}
              style={{
                border: '1px solid #e6e6e6',
                borderRadius: '8px',
                padding: '10px',
                marginBottom: '8px',
              }}
            >
              <p style={{ marginBottom: '6px', fontWeight: 600 }}>
                {platform ? platform.name : platformId}
              </p>
              <small>
                Text max: {platform && platform.textMaxChars}
                {' | '}Media max: {platform && platform.mediaMaxItems}
              </small>

              <div style={{ marginTop: '10px' }}>
                <p style={{ marginBottom: '6px', fontWeight: 600 }}>
                  Image editor ({cropSpec.width} x {cropSpec.height})
                </p>
                <small>
                  Crop frame matches this outlet's image aspect ratio.
                </small>

                <div
                  style={{ marginTop: '8px', marginBottom: '8px' }}
                >
                  <label
                    htmlFor={fileInputId}
                    style={{
                      display: 'inline-block',
                      background: '#f21d59',
                      color: '#ffffff',
                      padding: '8px 12px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontWeight: 600,
                      marginBottom: 0,
                    }}
                  >
                    Change Image
                  </label>
                  <input
                    id={fileInputId}
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={(event) => {
                      const file =
                        event.target.files && event.target.files[0]
                          ? event.target.files[0]
                          : null;
                      this.uploadPlatformImage(platformId, file);
                      event.target.value = '';
                    }}
                  />
                  {override.imageUploading && (
                    <small
                      style={{ display: 'block', marginTop: '4px' }}
                    >
                      Uploading image...
                    </small>
                  )}
                  {override.imageError && (
                    <small
                      style={{
                        display: 'block',
                        marginTop: '4px',
                        color: '#d93025',
                      }}
                    >
                      {override.imageError}
                    </small>
                  )}
                </div>

                <div
                  style={{
                    width: `${cropPreviewWidth}px`,
                    height: `${cropPreviewHeight}px`,
                    border: '2px dashed #bcbcbc',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    position: 'relative',
                    background: '#f4f4f4',
                    marginBottom: '8px',
                  }}
                >
                  {imageSource ? (
                    <img
                      src={imageSource}
                      alt={
                        platform ? platform.name : 'platform image'
                      }
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transform: `translate(-50%, -50%) translate(${cropX}px, ${cropY}px) scale(${cropScale})`,
                        transformOrigin: 'center center',
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#777',
                        fontSize: '12px',
                        padding: '10px',
                        textAlign: 'center',
                      }}
                    >
                      No image selected. Upload one from your device.
                    </div>
                  )}
                </div>

                {imageSource && (
                  <div style={{ marginBottom: '10px' }}>
                    <label
                      style={{
                        display: 'block',
                        marginBottom: '4px',
                      }}
                    >
                      Zoom: {Number(cropScale).toFixed(2)}x
                    </label>
                    <input
                      type="range"
                      min="1"
                      max="3"
                      step="0.01"
                      value={cropScale}
                      onChange={(event) => {
                        this.updatePlatformOverride(
                          platformId,
                          'cropScale',
                          Number(event.target.value),
                        );
                      }}
                      style={{ width: '100%' }}
                    />

                    <label
                      style={{
                        display: 'block',
                        marginBottom: '4px',
                      }}
                    >
                      Horizontal position: {Math.round(cropX)}px
                    </label>
                    <input
                      type="range"
                      min="-120"
                      max="120"
                      step="1"
                      value={cropX}
                      onChange={(event) => {
                        this.updatePlatformOverride(
                          platformId,
                          'cropX',
                          Number(event.target.value),
                        );
                      }}
                      style={{ width: '100%' }}
                    />

                    <label
                      style={{
                        display: 'block',
                        marginBottom: '4px',
                      }}
                    >
                      Vertical position: {Math.round(cropY)}px
                    </label>
                    <input
                      type="range"
                      min="-120"
                      max="120"
                      step="1"
                      value={cropY}
                      onChange={(event) => {
                        this.updatePlatformOverride(
                          platformId,
                          'cropY',
                          Number(event.target.value),
                        );
                      }}
                      style={{ width: '100%' }}
                    />

                    <button
                      className="cancelButton"
                      style={{
                        marginTop: '8px',
                        borderRadius: '6px',
                      }}
                      onClick={() => {
                        this.resetPlatformImageEdit(platformId);
                      }}
                    >
                      Reset image positioning
                    </button>
                  </div>
                )}
              </div>

              <textarea
                className="form-control"
                rows="2"
                placeholder="Optional text override"
                style={{ marginTop: '8px' }}
                value={override.textOverride || ''}
                onChange={(event) => {
                  this.updatePlatformOverride(
                    platformId,
                    'textOverride',
                    event.target.value,
                  );
                }}
              />
              <label style={{ marginTop: '8px' }}>
                <input
                  type="checkbox"
                  checked={override.cropConfirmed === true}
                  onChange={(event) => {
                    this.updatePlatformOverride(
                      platformId,
                      'cropConfirmed',
                      event.target.checked,
                    );
                  }}
                />{' '}
                Crop/preview confirmed for this platform
              </label>
            </div>
          );
        })}
      </div>
    );
  }

  getCreatePanel() {
    return (
      <div className="section">
        <div
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <h3>
            {this.state.editingPostId
              ? 'Edit Post'
              : 'Create New Post'}
          </h3>
          <div>
            <button
              className=""
              style={{
                background: '#f21d59',
                color: '#ffffff',
                borderRadius: '6px',
                padding: '8px 12px',
                fontWeight: 600,
                border: 'none',
              }}
              onClick={() => {
                this.setState({
                  createOpen: !this.state.createOpen,
                });
              }}
            >
              {this.state.createOpen ? 'Close' : 'Create New Post'}
            </button>
          </div>
        </div>

        {this.state.createOpen && (
          <div>
            {this.getContentTypeSelector()}
            {this.getContentPicker()}
            {this.getPlatformSelector()}
            {this.getComposer()}
            {this.getPerPlatformFormatting()}
            <div style={{ marginTop: '12px' }}>
              <label style={{ marginRight: '10px' }}>
                <input
                  type="radio"
                  name="social-post-status"
                  checked={this.state.status === 'draft'}
                  onChange={() => {
                    this.setState({
                      status: 'draft',
                      scheduleValidationError: '',
                    });
                  }}
                />{' '}
                Save as Draft
              </label>
              <label>
                <input
                  type="radio"
                  name="social-post-status"
                  checked={this.state.status === 'queued'}
                  onChange={() => {
                    this.setState({
                      status: 'queued',
                      scheduleValidationError: '',
                    });
                  }}
                />{' '}
                Schedule for Later
              </label>
              <label style={{ marginLeft: '10px' }}>
                <input
                  type="radio"
                  name="social-post-status"
                  checked={this.state.status === 'published'}
                  onChange={() => {
                    this.setState({
                      status: 'published',
                      scheduleValidationError: '',
                    });
                  }}
                />{' '}
                Publish Now
              </label>
            </div>
            {this.state.status === 'queued' && (
              <div
                style={{
                  marginTop: '10px',
                  padding: '10px',
                  border: '1px solid #e6e6e6',
                  borderRadius: '8px',
                  background: '#fafafa',
                }}
              >
                <p style={{ marginBottom: '8px', fontWeight: 600 }}>
                  Schedule publish date & time
                </p>
                <Row>
                  <Col xs={12} md={6} sm={6} lg={6}>
                    <label>Date</label>
                    <DatePicker
                      onChange={(value) => {
                        this.setState({
                          scheduledDate: value,
                          scheduleValidationError: '',
                        });
                      }}
                      value={this.state.scheduledDate}
                      minDate={new Date()}
                      clearIcon={null}
                      format="y-MM-dd"
                    />
                  </Col>
                  <Col xs={12} md={6} sm={6} lg={6}>
                    <label>Time</label>
                    <TimePicker
                      onChange={(value) => {
                        this.setState({
                          scheduledTime: value || '09:00',
                          scheduleValidationError: '',
                        });
                      }}
                      value={this.state.scheduledTime}
                      disableClock={true}
                      clearIcon={null}
                      format="HH:mm"
                    />
                  </Col>
                </Row>
                {this.state.scheduleValidationError && (
                  <p style={{ color: '#d93025', marginTop: '8px' }}>
                    {this.state.scheduleValidationError}
                  </p>
                )}
              </div>
            )}
            <button
              className=""
              style={{
                marginTop: '10px',
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto',
                background: '#f21d59',
                color: '#ffffff',
                borderRadius: '6px',
                padding: '8px 12px',
                fontWeight: 600,
                border: 'none',
              }}
              onClick={() => {
                this.createPost();
              }}
            >
              {this.props.socialMedia.saving
                ? 'Saving...'
                : this.state.editingPostId
                  ? 'Publish'
                  : 'Publish'}
            </button>
            {/* <button
              className="saveButton"
              style={{ marginTop: '10px', marginLeft: '8px' }}
              onClick={() => {
                this.pushComposerToSocialNow();
              }}
            >
              Push to Social Media
            </button> */}
          </div>
        )}
      </div>
    );
  }

  getPostList() {
    const allPosts = this.props.posts || [];
    const publishedPosts = allPosts.filter(
      (post) => post.status === 'published',
    );
    const draftPosts = allPosts.filter(
      (post) => !post.status || post.status === 'draft',
    );
    const scheduledPosts = allPosts.filter(
      (post) => post.status === 'queued',
    );

    const formatScheduledFor = (post) => {
      if (!post || !post.scheduledFor) {
        return '';
      }
      const date = new Date(post.scheduledFor);
      if (Number.isNaN(date.getTime())) {
        return '';
      }
      return date.toLocaleString();
    };

    const renderPostCard = (post) => {
      const hasSourceImage =
        post.sourceContent && post.sourceContent.image;

      return (
        <div
          key={post.id}
          style={{
            border: '1px solid #e6e6e6',
            borderRadius: '8px',
            padding: '10px',
            marginBottom: '8px',
            background: '#fff',
          }}
        >
          <Row>
            {hasSourceImage && (
              <Col xs={12} md={3} sm={3} lg={3}>
                <img
                  src={post.sourceContent.image}
                  alt={
                    post.sourceContent && post.sourceContent.title
                      ? post.sourceContent.title
                      : 'Post source'
                  }
                  style={{
                    width: '100%',
                    maxHeight: '140px',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    marginBottom: '8px',
                  }}
                />
              </Col>
            )}
            <Col
              xs={12}
              md={hasSourceImage ? 6 : 9}
              sm={hasSourceImage ? 6 : 9}
              lg={hasSourceImage ? 6 : 9}
            >
              <p style={{ margin: 0, fontWeight: 600 }}>
                {post.sourceContent && post.sourceContent.title
                  ? post.sourceContent.title
                  : 'Custom Post'}
              </p>
              <p style={{ margin: '5px 0 0 0' }}>{post.postText}</p>
              <small>
                Type: {post.contentType} {' | '}Status: {post.status}{' '}
                {' | '}Platforms:{' '}
                {post.selectedPlatforms
                  ? post.selectedPlatforms.join(', ')
                  : ''}
              </small>
              {post.status === 'queued' && post.scheduledFor && (
                <small style={{ display: 'block', marginTop: '4px' }}>
                  Scheduled For: {formatScheduledFor(post)}
                </small>
              )}
            </Col>
            <Col xs={12} md={3} sm={3} lg={3}>
              <button
                className=""
                style={{
                  marginBottom: '8px',
                  background: '#f21d59',
                  color: '#ffffff',
                  borderRadius: '6px',
                  padding: '8px 12px',
                  fontWeight: 600,
                  border: 'none',
                }}
                onClick={() => {
                  this.pushSavedPost(post);
                }}
              >
                Publish Now
              </button>
              <button
                className=""
                style={{
                  marginBottom: '8px',
                  background: '#f21d59',
                  color: '#ffffff',
                  borderRadius: '6px',
                  padding: '8px 12px',
                  fontWeight: 600,
                  border: 'none',
                }}
                onClick={() => {
                  this.editPost(post);
                }}
              >
                Edit
              </button>
              <button
                className="cancelButton"
                style={{ borderRadius: '6px' }}
                onClick={() => {
                  this.removePost(post.id);
                }}
              >
                Delete
              </button>
            </Col>
          </Row>
        </div>
      );
    };

    return (
      <div className="section">
        <h3>Drafts</h3>
        {draftPosts.length === 0 ? (
          <p>No drafts yet.</p>
        ) : (
          draftPosts.map((post) => renderPostCard(post))
        )}

        <h3 style={{ marginTop: '18px' }}>Scheduled for Later</h3>
        {scheduledPosts.length === 0 ? (
          <p>No scheduled posts yet.</p>
        ) : (
          scheduledPosts.map((post) => renderPostCard(post))
        )}

        <h3 style={{ marginTop: '18px' }}>
          Previous Posts (Published)
        </h3>
        {publishedPosts.length === 0 ? (
          <p>No published posts yet.</p>
        ) : (
          publishedPosts.map((post) => renderPostCard(post))
        )}
      </div>
    );
  }

  getAppContent() {
    return (
      <div
        style={{
          height: '100%',
        }}
        id="vendor"
      >
        <div className="appMenuNew mobileHide">
          <VendorMenu popupMenu={false} />
        </div>
        <div id="vendorScreenBody">
          <div style={{ padding: '10px', margin: '0px auto' }}>
            <div className="section">
              <Container>
                <Row>
                  <Col xs={12} md={12} sm={12} lg={12}>
                    <h2>Social Media</h2>
                    <p>
                      Build once, post to multiple platforms, and
                      manage previous posts.
                    </p>
                    {this.props.socialMedia.error && (
                      <p style={{ color: '#d93025' }}>
                        {this.props.socialMedia.error}
                      </p>
                    )}
                  </Col>
                </Row>
              </Container>
            </div>

            {this.getCreatePanel()}
            {this.getPostList()}
          </div>
        </div>
      </div>
    );
  }

  getTitleBar(title) {
    return (
      <div id="headersTop">
        <div className="backbar">
          <Row className="no-margin">
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="no-padding"
            >
              <span className="left">
                <MaterialIcon
                  icon="apps"
                  size={30}
                  color="#353535"
                  onClick={() => {
                    this.showPicker(true);
                  }}
                />
              </span>
              <span className="vendorAppTitle">{title}</span>

              <span className="helpButton">
                <Link
                  to={{
                    pathname: '/vendor/support',
                  }}
                >
                  <MaterialIcon
                    icon="help_outline"
                    size={35}
                    color="#353535"
                  />
                </Link>
              </span>
              <span className="right">
                <UserAvatar
                  size="30"
                  name={
                    this.props.profile.firstName +
                    this.props.profile.lastName
                  }
                  src={this.props.profile.profilePhotoPath}
                />
              </span>
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  render() {
    if (this.props.vendor === undefined) {
      return null;
    }

    return (
      <div id="vendor">
        {this.state.showPicker === true && (
          <VendorMenu showPicker={this.showPicker} popupMenu={true} />
        )}
        {this.getTitleBar('Social Media')}
        <div className="vendorContent">{this.getAppContent()}</div>
        <style
          dangerouslySetInnerHTML={{
            __html:
              'body{height: 100%} .toolbar{display:none} #analytics{height: 100%} .maincontent{margin-top: 60px; top:0px !important} .maincontent-push{height:100%} #bottomNav { display: none } #authleft{display:none;} #authright{padding-left:0px} #headersTop{width:100%}',
          }}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getMode: (mode) => {
      dispatch(getMode(mode));
    },
    getSocialConfig: () => {
      dispatch(getSocialConfig());
    },
    getVendorSocialContent: (vendorId, contentType) => {
      dispatch(getVendorSocialContent(vendorId, contentType));
    },
    getVendorSocialPosts: (vendorId) => {
      dispatch(getVendorSocialPosts(vendorId));
    },
    createVendorSocialPost: (bundle) => {
      dispatch(createVendorSocialPost(bundle));
    },
    updateVendorSocialPost: (bundle) => {
      dispatch(updateVendorSocialPost(bundle));
    },
    deleteVendorSocialPost: (vendorId, postId) => {
      dispatch(deleteVendorSocialPost(vendorId, postId));
    },
    pushVendorSocialPostNow: (bundle) => {
      dispatch(pushVendorSocialPostNow(bundle));
    },
  };
};

function mapStateToProps(state) {
  return {
    vendor: state.vendor.vendor,
    mode: state.mode.mode,
    profile: state.profile.profile,
    socialMedia: state.socialMedia,
    platforms: state.socialMedia.platforms,
    vendorContent: state.socialMedia.vendorContent,
    posts: state.socialMedia.posts,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VendorSocialMedia);
